import React, { Component } from "react";
import { observer } from "mobx-react";
import "./TrackToUpload.scss";
import TrackToUploadState from "./TrackToUploadState";

/**
 * @typedef {Object} TrackToUploadProps
 * @property {TrackToUploadState} store - The track to upload state store
 */

@observer
class TrackToUpload extends Component {
  render() {
    const mp3File = this.props.store.mp3File;
    const wavFile = this.props.store.wavFile;
    const replacing = this.props.store.isReplacing;

    let mp3View;
    let wavView;

    const bothEnabled = mp3File && wavFile ? "Enabled-both" : "Enabled-one";
    const needsBoth =
      mp3File && wavFile ? "" : "Needs Both an Mp3 and a Wav file";
    const isReplacing = replacing ? "Is-Replacing" : "";
    const isReplacingText = isReplacing
      ? "Replacing a track with the same name and tags"
      : "";

    if (this.props.store.uploading) {
      if (mp3File == null || wavFile == null) {
        // This is an error state
        return (
          <div className={"UploadTrack"}>
            Something went wrong in the upload... Please try refreshing the
            page.
          </div>
        );
      }
    }

    if (mp3File) {
      mp3View = (
        <div className={"UploadTrack-section"}>
          <div>
            <div className={"UploadTrack-section"}>
              <div className={"TrackName"}>
                {this.props.store.mp3File.name} duration:
{" "}
                {this.props.store.mp3Duration}s
              </div>
              <div className={"UploadTrack-progress-holder"}>
                <div
                  className={"UploadTrack-progress-bar"}
                  style={{
                    width: `${this.props.store.mp3UploadProgress * 100}%`
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      );
    }
    if (wavFile) {
      wavView = (
        <div className={"UploadTrack-section"}>
          <div>
            <div className={"UploadTrack-section"}>
              <div className={"TrackName"}>
                {this.props.store.wavFile.name} duration:
{" "}
                {this.props.store.wavDuration}s
              </div>
              <div className={"UploadTrack-progress-holder"}>
                <div
                  className={"UploadTrack-progress-bar"}
                  style={{
                    width: `${this.props.store.wavUploadProgress * 100}%`
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className={`TrackToUpload ${bothEnabled} ${isReplacing}`}>
        <div className={"TrackName"}>
          {this.props.store.trackName}
          <span className={"NeedsBoth"}>
            {needsBoth}
            <span>{isReplacingText}</span>
          </span>
        </div>
        {mp3View}
        {wavView}
        {/* <div className={"UploadTrack-section"}> */}
        {/*  <button onClick={this.props.store.remove}>Remove</button> */}
        {/* </div> */}
      </div>
    );
    /*
    return (
      <div className={"TrackToUpload"}>
        <div className={"UploadTrack-section"}>
          <div>
            Choose the mp3 version (duration {this.props.store.mp3Duration}s):{" "}
            <input
              type={"file"}
              accept={".mp3"}
              onChange={(fileEvent: SyntheticInputEvent<HTMLInputElement>) => {
                this.props.store.setMp3(fileEvent.target.files[0]);
              }}
            />
          </div>
        </div>
        <div className={"UploadTrack-section"}>
          <div>
            Choose the wav version (duration {this.props.store.wavDuration}s):{" "}
            <input
              type={"file"}
              accept={".wav"}
              onChange={(fileEvent: SyntheticInputEvent<HTMLInputElement>) => {
                this.props.store.setWav(fileEvent.target.files[0]);
              }}
            />
          </div>
        </div>
        <div className={"UploadTrack-section"}>
          <button onClick={this.props.store.remove}>Remove</button>
        </div>
      </div>
    );
    */
  }
}

export default TrackToUpload;
